import '../styles/HistoryMasthead.css';
import React from 'react';

function HistoryMasthead() {
  return (
    <section className="hm-masthead" aria-labelledby="hm-title">
      <div className="hm-rail" data-content-rail="workspace">
        <div className="hm-grid">
          <div className="hm-main">
            <p className="hm-eyebrow">Brute · Persisted runs</p>
            <h1 id="hm-title" className="hm-title">Run History</h1>
            <p className="hm-subline">
              Every persisted run, across sessions — available to operators and administrators.
            </p>
          </div>

          <div className="hm-action">
            <div className="hm-sticker-wrap">
              <span className="hm-sticker">
                <span className="hm-sticker-dot" aria-hidden="true" />
                Authorized target only
              </span>
            </div>
            <a className="hm-return" href="/dashboard">
              <span className="hm-return-arrow" aria-hidden="true">←</span>
              Return to Dashboard
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HistoryMasthead;